module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiPjxwYXRoIGZpbGw9IiMzRjUxQjUiIGQ9Ik00MiwzN2MwLDIuNzYyLTIuMjM4LDUtNSw1SDExYy0yLjc2MSwwLTUtMi4yMzgtNS01VjExYzAtMi43NjIsMi4yMzktNSw1LTVoMjZjMi43NjIsMCw1LDIuMjM4LDUsNVYzN3oiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMzQuMzY4LDI1SDMxdjEzaC01VjI1aC0zdi00aDN2LTIuNDFjMC4wMDItMy41MDgsMS40NTktNS41OSw1LjU5Mi01LjU5SDM1djRoLTIuMjg3QzMxLjEwNCwxNywzMSwxNy42LDMxLDE4LjcyM1YyMWg0TDM0LjM2OCwyNXoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/routes/SuccessPayment/assets/icons8-facebook.svg
// module id = 1555
// module chunks = 9